/* ─── Positioner ─── */

.positioner {
  z-index: var(--z-popover);
}

/* ─── Popup ─── */

.popup {
  background: var(--md-surface-container-lowest);
  box-shadow: var(--elevation-3);
  border: 1px solid var(--md-outline-variant);
  border-radius: var(--shape-md);
  min-width: 112px;
  max-width: 320px;
  padding: var(--space-2);
  outline: none;
  font-family: var(--font-sans);
  transition: opacity var(--motion-duration-short3)
      var(--motion-easing-standard),
    transform var(--motion-duration-short3) var(--motion-easing-standard);
  transform-origin: var(--transform-origin);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.95);
}

/* ─── Item ─── */

.item {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  height: 3rem;
  padding: 0 var(--space-3);
  border: none;
  border-radius: var(--shape-sm);
  background: transparent;
  color: var(--md-on-surface-variant);
  font-family: var(--font-sans);
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  text-align: start;
}

.item::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .item:hover::before {
    opacity: var(--state-hover);
  }
}

.item:focus-visible::before {
  opacity: var(--state-focus);
}

.item:active::before {
  opacity: var(--state-pressed);
}

.item[data-highlighted]::before {
  opacity: var(--state-hover);
}

.item[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

.item[data-disabled]::before {
  display: none;
}

/* ─── Leading / trailing slots ─── */

.leading {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.trailing {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
  flex-shrink: 0;
  margin-inline-start: auto;
}

/* ─── Checkbox / Radio indicator ─── */

.indicator {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.indicator svg {
  width: 1rem;
  height: 1rem;
}

/* ─── Separator ─── */

.separator {
  height: 1px;
  background: var(--md-outline-variant);
  margin: var(--space-1) 0;
  border: none;
}

/* ─── Group label ─── */

.groupLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
  padding: var(--space-2) var(--space-3);
}

/* ─── Submenu trigger chevron ─── */

.submenuChevron {
  width: 1rem;
  height: 1rem;
  margin-inline-start: auto;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

/* ─── Arrow ─── */

.arrow {
  width: 10px;
  height: 10px;
}

/* ─── Backdrop ─── */

.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
}
